import { Autocomplete, Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import countries from "utils/countries/countries";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const CountryField = ({
  options,
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  questionType,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [commentBox, setCommentBox] = useState("");
  const [country, setCountry] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  const { brmData } = useSelector((state) => state);

  const handleChange = (type, value) => {
    if (type === "country") {
      setCountry(value || "");
    } else if (type === "comment") {
      setCommentBox(value);
    } else if (type === "document") setAttachDocument(value);

    if (isFrom === "taskSection") {
      const obj = {
        value: type === "country" ? value : country,
        weightage: 1,
        comment: type === "comment" ? value : commentBox,
        supporting_document:
          type === "document" && value === null ? value : attachDocument,
        document: type === "document" ? value : attachDocument,
        documentMetaData:
          type === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };
  useEffect(() => {
    if (submittedAnswer && submittedAnswer?.length > 0) {
      setCountry(submittedAnswer?.[0]?.value);
      setCommentBox(submittedAnswer?.[0]?.comment);
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" }, // Adjust placeholder font size
    },
  };

  const labelSize = {
    style: { fontSize: "14px" }, // Adjust label font size
  };
  const safeCountry = countries.map((c) => c.label).includes(country)
    ? country
    : null;

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <Box my={2}>
        {submittedAnswer &&
        submittedAnswer?.[0]?.option &&
        isFrom === "submissionSection" ? (
          <TextField
            value={submittedAnswer?.[0]?.option}
            variant="outlined"
            disabled={true}
            fullWidth
            size="small"
          />
        ) : (
          <Autocomplete
            name="compCountry"
            id="countryCode"
            options={countries.map((c) => c?.label || "")}
            getOptionLabel={(option) => option || ""}
            // renderOption={(option) => option}
            size="small"
            value={safeCountry}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Country"}
                variant="outlined"
                InputLabelProps={labelSize}
              />
            )}
            onChange={(event, newValue) => handleChange("country", newValue)}
          />
        )}
      </Box>

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default CountryField;
